import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-route3',
    templateUrl: './route3.component.html',
    styleUrls: ['./route3.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Route3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
